<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Dr. Anthony Mathews:</p>
<p>Married.</p>
<p>Studied in Germany, Spain, Russia, and England: Diplomacy, International Relations, International Rights, Foreign Affairs, and Business Administration.</p>
<p>Doctorate in International Relations and Business Administration.</p>
<p>He always writes by hand. He writes because he loves literature, without commercial interest. He writes as he wants and without any pressure on sales, marketing, or recognition.</p>
<p>As a kid, he lived in different countries, so he is a cosmopolitan with a deep respect for diverse cultures, peoples, and nationalities, and he speaks many languages.</p>
<p>He is confident that the reader will find a phrase to reflect on, think about, or discuss with someone or with oneself.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7977e080